// Layout of the Conditions Générales d’Utilisation (Candidats) page.
// Every text value is a translation key; the strings live in static/locales/<lang>/translation.json.

const legalCgu = {
	"title": "legal_cgu_title",
	"subtitle": "legal_cgu_subtitle",
	"updated": "legal_cgu_updated",
	"sections": [
		{
			"id": "preambule",
			"title": "legal_cgu_preambule_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_cgu_preambule_p1"
				}
			]
		},
		{
			"id": "regles",
			"highlight": true,
			"title": "legal_cgu_regles_title",
			"blocks": [
				{
					"type": "note",
					"text": "legal_cgu_regles_note1"
				},
				{
					"type": "p",
					"text": "legal_cgu_regles_p2"
				},
				{
					"type": "list",
					"style": "alpha",
					"items": [
						"legal_cgu_regles_list3_a",
						"legal_cgu_regles_list3_b",
						"legal_cgu_regles_list3_c"
					]
				},
				{
					"type": "p",
					"text": "legal_cgu_regles_p4"
				},
				{
					"type": "p",
					"text": "legal_cgu_regles_p5"
				}
			]
		},
		{
			"id": "definitions",
			"number": "1",
			"title": "legal_cgu_definitions_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_cgu_definitions_p1"
				},
				{
					"type": "definitions",
					"items": [
						{
							"term": "legal_cgu_definitions_def1_term",
							"text": "legal_cgu_definitions_def1_text"
						},
						{
							"term": "legal_cgu_definitions_def2_term",
							"text": "legal_cgu_definitions_def2_text"
						},
						{
							"term": "legal_cgu_definitions_def3_term",
							"text": "legal_cgu_definitions_def3_text"
						},
						{
							"term": "legal_cgu_definitions_def4_term",
							"text": "legal_cgu_definitions_def4_text"
						},
						{
							"term": "legal_cgu_definitions_def5_term",
							"text": "legal_cgu_definitions_def5_text"
						},
						{
							"term": "legal_cgu_definitions_def6_term",
							"text": "legal_cgu_definitions_def6_text"
						},
						{
							"term": "legal_cgu_definitions_def7_term",
							"text": "legal_cgu_definitions_def7_text"
						},
						{
							"term": "legal_cgu_definitions_def8_term",
							"text": "legal_cgu_definitions_def8_text"
						},
						{
							"term": "legal_cgu_definitions_def9_term",
							"text": "legal_cgu_definitions_def9_text"
						},
						{
							"term": "legal_cgu_definitions_def10_term",
							"text": "legal_cgu_definitions_def10_text"
						},
						{
							"term": "legal_cgu_definitions_def11_term",
							"text": "legal_cgu_definitions_def11_text"
						},
						{
							"term": "legal_cgu_definitions_def12_term",
							"text": "legal_cgu_definitions_def12_text"
						},
						{
							"term": "legal_cgu_definitions_def13_term",
							"text": "legal_cgu_definitions_def13_text"
						}
					]
				}
			]
		},
		{
			"id": "objet",
			"number": "2",
			"title": "legal_cgu_objet_title",
			"blocks": [
				{
					"type": "clause",
					"num": "2.1",
					"text": "legal_cgu_objet_2_1_text"
				},
				{
					"type": "clause",
					"num": "2.2",
					"text": "legal_cgu_objet_2_2_text"
				},
				{
					"type": "clause",
					"num": "2.3",
					"text": "legal_cgu_objet_2_3_text"
				}
			]
		},
		{
			"id": "acces",
			"number": "3",
			"title": "legal_cgu_acces_title",
			"blocks": [
				{
					"type": "clause",
					"num": "3.1",
					"text": "legal_cgu_acces_3_1_text"
				},
				{
					"type": "clause",
					"num": "3.2",
					"text": "legal_cgu_acces_3_2_text"
				},
				{
					"type": "clause",
					"num": "3.3",
					"text": "legal_cgu_acces_3_3_text"
				},
				{
					"type": "clause",
					"num": "3.4",
					"text": "legal_cgu_acces_3_4_text"
				},
				{
					"type": "clause",
					"num": "3.5",
					"text": "legal_cgu_acces_3_5_text"
				}
			]
		},
		{
			"id": "obligations",
			"number": "4",
			"title": "legal_cgu_obligations_title",
			"blocks": [
				{
					"type": "clause",
					"num": "4.1",
					"text": "legal_cgu_obligations_4_1_text",
					"list": [
						"legal_cgu_obligations_4_1_a",
						"legal_cgu_obligations_4_1_b",
						"legal_cgu_obligations_4_1_c",
						"legal_cgu_obligations_4_1_d"
					]
				},
				{
					"type": "clause",
					"num": "4.2",
					"text": "legal_cgu_obligations_4_2_text"
				},
				{
					"type": "clause",
					"num": "4.3",
					"text": "legal_cgu_obligations_4_3_text"
				},
				{
					"type": "clause",
					"num": "4.4",
					"text": "legal_cgu_obligations_4_4_text"
				}
			]
		},
		{
			"id": "sessions",
			"number": "5",
			"title": "legal_cgu_sessions_title",
			"blocks": [
				{
					"type": "clause",
					"num": "5.1",
					"text": "legal_cgu_sessions_5_1_text",
					"list": [
						"legal_cgu_sessions_5_1_a",
						"legal_cgu_sessions_5_1_b",
						"legal_cgu_sessions_5_1_c"
					]
				},
				{
					"type": "clause",
					"num": "5.2",
					"text": "legal_cgu_sessions_5_2_text",
					"list": [
						"legal_cgu_sessions_5_2_a",
						"legal_cgu_sessions_5_2_b",
						"legal_cgu_sessions_5_2_c",
						"legal_cgu_sessions_5_2_d",
						"legal_cgu_sessions_5_2_e",
						"legal_cgu_sessions_5_2_f"
					]
				},
				{
					"type": "clause",
					"num": "5.3",
					"text": "legal_cgu_sessions_5_3_text"
				},
				{
					"type": "clause",
					"num": "5.4",
					"text": "legal_cgu_sessions_5_4_text"
				},
				{
					"type": "clause",
					"num": "5.5",
					"text": "legal_cgu_sessions_5_5_text"
				}
			]
		},
		{
			"id": "telesurveillance",
			"number": "6",
			"title": "legal_cgu_telesurveillance_title",
			"blocks": [
				{
					"type": "clause",
					"num": "6.1",
					"text": "legal_cgu_telesurveillance_6_1_text"
				},
				{
					"type": "clause",
					"num": "6.2",
					"text": "legal_cgu_telesurveillance_6_2_text"
				},
				{
					"type": "clause",
					"num": "6.3",
					"text": "legal_cgu_telesurveillance_6_3_text"
				},
				{
					"type": "clause",
					"num": "6.4",
					"text": "legal_cgu_telesurveillance_6_4_text"
				},
				{
					"type": "clause",
					"num": "6.5",
					"text": "legal_cgu_telesurveillance_6_5_text"
				}
			]
		},
		{
			"id": "donnees-personnelles",
			"number": "7",
			"title": "legal_cgu_donnees_personnelles_title",
			"blocks": [
				{
					"type": "clause",
					"num": "7.1",
					"label": "legal_cgu_donnees_personnelles_7_1_label",
					"text": "legal_cgu_donnees_personnelles_7_1_text",
					"list": [
						"legal_cgu_donnees_personnelles_7_1_a",
						"legal_cgu_donnees_personnelles_7_1_b"
					]
				},
				{
					"type": "clause",
					"num": "7.2",
					"label": "legal_cgu_donnees_personnelles_7_2_label",
					"text": "legal_cgu_donnees_personnelles_7_2_text"
				},
				{
					"type": "clause",
					"num": "7.3",
					"label": "legal_cgu_donnees_personnelles_7_3_label",
					"text": "legal_cgu_donnees_personnelles_7_3_text"
				},
				{
					"type": "clause",
					"num": "7.4",
					"label": "legal_cgu_donnees_personnelles_7_4_label",
					"text": "legal_cgu_donnees_personnelles_7_4_text",
					"list": [
						"legal_cgu_donnees_personnelles_7_4_a",
						"legal_cgu_donnees_personnelles_7_4_b",
						"legal_cgu_donnees_personnelles_7_4_c",
						"legal_cgu_donnees_personnelles_7_4_d"
					],
					"after": "legal_cgu_donnees_personnelles_7_4_after"
				},
				{
					"type": "clause",
					"num": "7.5",
					"label": "legal_cgu_donnees_personnelles_7_5_label",
					"text": "legal_cgu_donnees_personnelles_7_5_text"
				},
				{
					"type": "clause",
					"num": "7.6",
					"label": "legal_cgu_donnees_personnelles_7_6_label",
					"text": "legal_cgu_donnees_personnelles_7_6_text",
					"list": [
						"legal_cgu_donnees_personnelles_7_6_a",
						"legal_cgu_donnees_personnelles_7_6_b",
						"legal_cgu_donnees_personnelles_7_6_c"
					]
				},
				{
					"type": "clause",
					"num": "7.7",
					"label": "legal_cgu_donnees_personnelles_7_7_label",
					"text": "legal_cgu_donnees_personnelles_7_7_text"
				},
				{
					"type": "clause",
					"num": "7.8",
					"label": "legal_cgu_donnees_personnelles_7_8_label",
					"text": "legal_cgu_donnees_personnelles_7_8_text"
				},
				{
					"type": "clause",
					"num": "7.9",
					"label": "legal_cgu_donnees_personnelles_7_9_label",
					"text": "legal_cgu_donnees_personnelles_7_9_text"
				},
				{
					"type": "clause",
					"num": "7.10",
					"label": "legal_cgu_donnees_personnelles_7_10_label",
					"text": "legal_cgu_donnees_personnelles_7_10_text"
				}
			]
		},
		{
			"id": "candidats-internationaux",
			"number": "8",
			"title": "legal_cgu_candidats_internationaux_title",
			"blocks": [
				{
					"type": "clause",
					"num": "8.1",
					"text": "legal_cgu_candidats_internationaux_8_1_text"
				},
				{
					"type": "clause",
					"num": "8.2",
					"text": "legal_cgu_candidats_internationaux_8_2_text"
				},
				{
					"type": "clause",
					"num": "8.3",
					"text": "legal_cgu_candidats_internationaux_8_3_text"
				},
				{
					"type": "clause",
					"num": "8.4",
					"text": "legal_cgu_candidats_internationaux_8_4_text"
				}
			]
		},
		{
			"id": "propriete-intellectuelle",
			"number": "9",
			"title": "legal_cgu_propriete_intellectuelle_title",
			"blocks": [
				{
					"type": "clause",
					"num": "9.1",
					"text": "legal_cgu_propriete_intellectuelle_9_1_text"
				},
				{
					"type": "clause",
					"num": "9.2",
					"text": "legal_cgu_propriete_intellectuelle_9_2_text"
				},
				{
					"type": "clause",
					"num": "9.3",
					"text": "legal_cgu_propriete_intellectuelle_9_3_text"
				}
			]
		},
		{
			"id": "responsabilite",
			"number": "10",
			"title": "legal_cgu_responsabilite_title",
			"blocks": [
				{
					"type": "clause",
					"num": "10.1",
					"text": "legal_cgu_responsabilite_10_1_text"
				},
				{
					"type": "clause",
					"num": "10.2",
					"text": "legal_cgu_responsabilite_10_2_text",
					"list": [
						"legal_cgu_responsabilite_10_2_a",
						"legal_cgu_responsabilite_10_2_b",
						"legal_cgu_responsabilite_10_2_c",
						"legal_cgu_responsabilite_10_2_d",
						"legal_cgu_responsabilite_10_2_e",
						"legal_cgu_responsabilite_10_2_f"
					]
				},
				{
					"type": "clause",
					"num": "10.3",
					"text": "legal_cgu_responsabilite_10_3_text"
				},
				{
					"type": "clause",
					"num": "10.4",
					"text": "legal_cgu_responsabilite_10_4_text"
				}
			]
		},
		{
			"id": "irregularites",
			"number": "11",
			"title": "legal_cgu_irregularites_title",
			"blocks": [
				{
					"type": "clause",
					"num": "11.1",
					"text": "legal_cgu_irregularites_11_1_text",
					"list": [
						"legal_cgu_irregularites_11_1_a",
						"legal_cgu_irregularites_11_1_b",
						"legal_cgu_irregularites_11_1_c",
						"legal_cgu_irregularites_11_1_d",
						"legal_cgu_irregularites_11_1_e",
						"legal_cgu_irregularites_11_1_f",
						"legal_cgu_irregularites_11_1_g",
						"legal_cgu_irregularites_11_1_h",
						"legal_cgu_irregularites_11_1_i"
					]
				},
				{
					"type": "clause",
					"num": "11.2",
					"text": "legal_cgu_irregularites_11_2_text"
				},
				{
					"type": "clause",
					"num": "11.3",
					"text": "legal_cgu_irregularites_11_3_text"
				},
				{
					"type": "clause",
					"num": "11.4",
					"text": "legal_cgu_irregularites_11_4_text"
				}
			]
		},
		{
			"id": "contestations",
			"number": "12",
			"title": "legal_cgu_contestations_title",
			"blocks": [
				{
					"type": "clause",
					"num": "12.1",
					"text": "legal_cgu_contestations_12_1_text",
					"list": [
						"legal_cgu_contestations_12_1_a",
						"legal_cgu_contestations_12_1_b",
						"legal_cgu_contestations_12_1_c",
						"legal_cgu_contestations_12_1_d"
					]
				},
				{
					"type": "clause",
					"num": "12.2",
					"text": "legal_cgu_contestations_12_2_text"
				},
				{
					"type": "clause",
					"num": "12.3",
					"text": "legal_cgu_contestations_12_3_text"
				},
				{
					"type": "clause",
					"num": "12.4",
					"text": "legal_cgu_contestations_12_4_text"
				},
				{
					"type": "clause",
					"num": "12.5",
					"text": "legal_cgu_contestations_12_5_text"
				}
			]
		},
		{
			"id": "modification",
			"number": "13",
			"title": "legal_cgu_modification_title",
			"blocks": [
				{
					"type": "clause",
					"num": "13.1",
					"text": "legal_cgu_modification_13_1_text"
				},
				{
					"type": "clause",
					"num": "13.2",
					"text": "legal_cgu_modification_13_2_text"
				},
				{
					"type": "clause",
					"num": "13.3",
					"text": "legal_cgu_modification_13_3_text"
				}
			]
		},
		{
			"id": "fin-acces",
			"number": "14",
			"title": "legal_cgu_fin_acces_title",
			"blocks": [
				{
					"type": "clause",
					"num": "14.1",
					"text": "legal_cgu_fin_acces_14_1_text",
					"list": [
						"legal_cgu_fin_acces_14_1_a",
						"legal_cgu_fin_acces_14_1_b",
						"legal_cgu_fin_acces_14_1_c",
						"legal_cgu_fin_acces_14_1_d"
					]
				},
				{
					"type": "clause",
					"num": "14.2",
					"text": "legal_cgu_fin_acces_14_2_text"
				}
			]
		},
		{
			"id": "notifications",
			"number": "15",
			"title": "legal_cgu_notifications_title",
			"blocks": [
				{
					"type": "clause",
					"num": "15.1",
					"text": "legal_cgu_notifications_15_1_text"
				},
				{
					"type": "clause",
					"num": "15.2",
					"text": "legal_cgu_notifications_15_2_text"
				},
				{
					"type": "clause",
					"num": "15.3",
					"text": "legal_cgu_notifications_15_3_text"
				},
				{
					"type": "clause",
					"num": "15.4",
					"text": "legal_cgu_notifications_15_4_text"
				}
			]
		},
		{
			"id": "droit-applicable",
			"number": "16",
			"title": "legal_cgu_droit_applicable_title",
			"blocks": [
				{
					"type": "clause",
					"num": "16.1",
					"text": "legal_cgu_droit_applicable_16_1_text"
				},
				{
					"type": "clause",
					"num": "16.2",
					"text": "legal_cgu_droit_applicable_16_2_text"
				},
				{
					"type": "clause",
					"num": "16.3",
					"text": "legal_cgu_droit_applicable_16_3_text"
				},
				{
					"type": "clause",
					"num": "16.4",
					"text": "legal_cgu_droit_applicable_16_4_text"
				}
			]
		},
		{
			"id": "dispositions-diverses",
			"number": "17",
			"title": "legal_cgu_dispositions_diverses_title",
			"blocks": [
				{
					"type": "clause",
					"num": "17.1",
					"label": "legal_cgu_dispositions_diverses_17_1_label",
					"text": "legal_cgu_dispositions_diverses_17_1_text"
				},
				{
					"type": "clause",
					"num": "17.2",
					"label": "legal_cgu_dispositions_diverses_17_2_label",
					"text": "legal_cgu_dispositions_diverses_17_2_text"
				},
				{
					"type": "clause",
					"num": "17.3",
					"label": "legal_cgu_dispositions_diverses_17_3_label",
					"text": "legal_cgu_dispositions_diverses_17_3_text"
				}
			]
		},
		{
			"id": "contacts",
			"number": "18",
			"title": "legal_cgu_contacts_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_cgu_contacts_p1"
				},
				{
					"type": "list",
					"style": "alpha",
					"items": [
						"legal_cgu_contacts_list2_a",
						"legal_cgu_contacts_list2_b",
						"legal_cgu_contacts_list2_c",
						"legal_cgu_contacts_list2_d"
					]
				}
			]
		},
		{
			"id": "entree-en-vigueur",
			"number": "19",
			"title": "legal_cgu_entree_en_vigueur_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_cgu_entree_en_vigueur_p1"
				}
			]
		}
	]
};

export default legalCgu;
